export default __webpack_public_path__ + "static/media/emerald-add-icon.4a3a479e.svg";